import * as React from 'react';
const SvgCheckCircle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M12 5c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-2a9 9 0 1 0 .001 18.001A9 9 0 0 0 12 3"
    />
    <path
      fill="currentColor"
      d="M11.32 14.95c.23-.07.43-.27.82-.67l3.5-3.51c.2-.2.3-.3.33-.41.03-.1.03-.21 0-.31-.04-.11-.14-.21-.33-.41l-.28-.28c-.2-.2-.3-.3-.41-.33a.6.6 0 0 0-.23-.02c-.02 0-.05.01-.07.02-.11.04-.21.14-.41.33l-3.22 3.22-1.25-1.24c-.12-.12-.2-.2-.27-.25a.5.5 0 0 0-.14-.08.55.55 0 0 0-.31 0c-.11.04-.21.14-.41.33l-.28.28c-.2.2-.3.3-.33.41-.02.05-.02.1-.02.15s0 .11.02.16q.03.09.12.18c.05.06.13.13.22.23l1.52 1.52c.4.4.59.6.82.67.2.07.42.07.62 0z"
    />
  </svg>
);
export default SvgCheckCircle;
